import { getDefaultExportFromCjs as e } from './contact-channels154.js';
import { __require as c } from './contact-channels108.js';

var a=c();const t=e(a);

export { t as default };
//# sourceMappingURL=contact-channels66.js.map
